var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "ul",
      {
        staticClass: "nav nav-tabs setting-nav-tabs",
        attrs: { id: "tabTitle" }
      },
      [
        _vm._l(_vm.navTabs, function(item) {
          return [
            _vm.disabled && item.id !== "user-info"
              ? _c(
                  "li",
                  {
                    key: item.id,
                    staticClass: "disabled",
                    class: _vm.activeTab(item.id),
                    attrs: { id: item.id + "-tab" }
                  },
                  [
                    _c("a", [
                      _vm._v("\n          " + _vm._s(item.name) + "\n        ")
                    ])
                  ]
                )
              : _c(
                  "li",
                  {
                    key: item.id,
                    class: _vm.activeTab(item.id),
                    attrs: { id: item.id + "-tab" },
                    on: {
                      click: function($event) {
                        _vm.changeTab(item.id)
                      }
                    }
                  },
                  [
                    _c("a", [
                      _vm._v("\n          " + _vm._s(item.name) + "\n        ")
                    ])
                  ]
                )
          ]
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46a5ca51", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46a5ca51","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/setting/NavTabs.vue
// module id = null
// module chunks = 